<template>
  <div class="news d-flex align-center justify-center">
    <div class="news-content d-flex f-column align-center justify-center">
      <h3>溯源新闻</h3>
      <p>科技前沿、生猪新闻、区块链技术，溯源新闻、行业信息</p>
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index" @click="handleToDetail(item.id)">
          <el-image v-if='!item.file1' class="image" :src="require('@/assets/images/news_01.jpg')"></el-image>
          <el-image v-if='item.file1' class="image" :src="'https://trace.hogdata.cn/hogchain-boot/sys/common/static/'+item.file1"></el-image>
          <div class="info d-flex">
            <p class="flex-1 text-overflow">
              {{item.title}}
            </p>
            <span class="iconfont icon-arrowright"></span>
          </div>
        </div>
      </div>
      <div class="more">
        <span  @click="func()">更多新鲜动态>></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        model: '456456456456456',
        pageNo: 1,
        list:''
      }
    },
    mounted() {
      // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
      const url = 'https://trace.hogdata.cn/hogchain-boot/hogchain/hotchainBusNews/list';
      this.$http.get(url, {
        params: {
          pageNo: this.pageNo,
          pageSize: 20
        }
      }).then(
        response => {
          console.log(response.body.result.records)
          this.list=response.body.result.records
        },

        response => {
          alert('请求失败');
        },
      );
    },
   methods:{
        func(){
            this.$router.push({name: 'News',params:{ id:'1'}});
        },
        handleToDetail(e) {
          this.$router.push({path: '/news/news-detail?id='+e});
          // this.$router.push('/news/news-detail',params:{ id:e}})
        },
    }
  }
</script>

<style lang="scss" scoped>
  .news {
    padding-top: 1.225rem;

    &-content {
      h3 {
        font-size: 0.45rem;
        margin-bottom: 0.3rem;
      }

      p {
        font-size: 0.2rem;
        color: #666;
      }

      .list {
        width: 15rem;
        padding-top: 1rem;

        /* overflow: hidden; */
        .item {
          float: left;
          width: 4.75rem;
          background-color: #feffff;
          box-shadow: 0.025rem 0.025rem 0.05rem 0 rgba(153, 153, 153, 0.4);
          margin-right: 0.375rem;
          margin-bottom: 0.375rem;
          cursor: pointer;

          :hover {

            p,
            .icon-arrowright {
              color: #2373f0;
            }
          }

          &:nth-of-type(3n + 3) {
            margin-right: 0;
          }

          .image {
            display: block;
            width: 4.75rem;
            height: 3.125rem;
          }

          .info {
            width: 100%;
            height: 1rem;
            padding: 0.25rem;
            color: #666;

            p {
              padding-right: 0.125rem;
              line-height: 0.25rem;
              font-size: 0.225rem;
              box-sizing: border-box;
            }

            .icon-arrowright {
              line-height: 0.25rem;
              font-size: 0.225rem;
            }
          }
        }
      }

      .more {
        padding: 0.375rem 0 1.25rem;
        font-size: 0.25rem;
        color: #666;

        span {
          cursor: pointer;
        }
      }
    }
  }
</style>
